const formOptionSelectorLength = document.querySelectorAll('.product-form__option-selector').length;

if (formOptionSelectorLength > 1) {
  document.querySelectorAll('.product-form__option-selector input[type="radio"]').forEach( inputElement => {
    inputElement.addEventListener( 'change', () => {
      if (inputElement.name !== `option${formOptionSelectorLength}`) {

        const optionSelectorArray = [...document.querySelectorAll('.product-form__option-selector input[type="radio"]:checked')];

        const optionSelectedArray = optionSelectorArray.map( optionSelectedItem => {
          if (optionSelectedItem.name !== `option${formOptionSelectorLength}`) {
            return optionSelectedItem.value;
          }
        });

        document.querySelectorAll(`.product-form__option-selector input[name="option${formOptionSelectorLength}"]`).forEach( inputLastElement => {
          optionSelectedArray[optionSelectedArray.length - 1] = inputLastElement.value;
          const variantTitle = optionSelectedArray.join(' / ');
          
          const inputLabel = inputLastElement.parentElement.querySelector('label');
          const discountLabelSelector = inputLastElement.parentElement.querySelector('.block-swatch__discount-label');
          const discountSVG = '<svg xmlns="http://www.w3.org/2000/svg" width="46" height="23" viewBox="0 0 46 23" fill="none"><path d="M1.82178 0L46 3.91L40.3069 13.11L44.1782 23L0 18.86L5.69307 9.66L1.82178 0Z" fill="#35907E"></path></svg>';
          
          if (discountLabelSelector) discountLabelSelector.remove();
          
          variants.forEach( variant => {
            if (variant.available && variant.title == variantTitle && variant.compare_at_price > variant.price) {
              console.log(variant.available);
              const discount = Math.round((((variant.compare_at_price - variant.price) * 100) / variant.compare_at_price));
              const discountHTML = `<span class="block-swatch__discount-label">${discountSVG}<span style="color: #F6ECEC">${discount}%</span></span>`;
              
              inputLabel.innerHTML = inputLabel.innerHTML + discountHTML;
            }
          });
        });
      }
    });
  });
}